<template lang="html">
  <div class="quotation-layout">
    <BLBreadcrumb />
    <div class="forms-padding">
      <b-row class="row-eq-height">
        <b-col col lg="3" md="3" sm="12" cols="12" class="profile-menu-card">
            <ProfileMenu />
        </b-col>
        <b-col col lg="9" md="9" sm="12" cols="12" class="forms-quoation-card mb-100">
          <BLForm />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import BLBreadcrumb from "../components/BL/BLBreadcrumb.vue";
import ProfileMenu from "../components/Profile/profileMenu.vue";
import BLForm from "../components/BL/BLForm.vue";

export default {
  name: "BL",
  components: {
    BLBreadcrumb,
    ProfileMenu,
    BLForm,
  },
  methods: {},
};
</script>
<style lang="css">
.quotation-layout {
  padding-top: 25vh !important;
}
@media only screen and (max-width: 1077px) {
 .profile-menu-card{
     padding: 0px!important;
  }
  .forms-quoation-card{
      padding: 0px!important;
  }
}

</style>